<template>
  <div class="so-no-input">
    <el-tooltip placement="bottom-end" style="flex: 1">
      <div slot="content" v-html="tooltip||$t('SeaExport.NoData')" />
      <el-input v-model="firstLineVal" :disabled="disabled" @blur="firstLineValBlur" @change="triggerChange" />
    </el-tooltip>
    <el-tooltip class="item" placement="bottom-end" :disabled="disabled">
      <div slot="content" v-html="tooltip||$t('SeaExport.NoData')" />
      <span class="el-button el-button--primary el-button--mini" style="min-width:40px!important;margin-left:2px" type="primary" @click="showDialog=true">...</span>
    </el-tooltip>

    <el-form>
      <!-- 多行输入对话框 -->
      <el-dialog
        v-el-drag-dialog
        :visible.sync="showDialog"
        :title="resolvedTitle + $t('SeaExport.Select')"
        width="450px"
        :show-close="false"
        append-to-body
        :close-on-click-modal="false"
        class="app-main-inner"
      >
        <cargo-ag-grid
          :grid-options="gridOptions"
          :grid-params.sync="gridParams"
          :column-defs="columnDefs"
          :row-data="rowData"
          :auto-fit-content="false"
          style="width:100%;height:300px"
          @gridReady="params=>{gridApi=params.api}"
        />
        <span slot="footer" style="display: flex;justify-content: space-between;">
          <div v-show="!disabled">
            <el-button type="primary" @click="add">{{ $t('Payment.new') }}</el-button>
            <el-button type="danger" @click="remove">{{ $t('FileHistory.Delete') }}</el-button>
          </div>
          <div style="flex: 1;text-align: right;">
            <label @click="save();triggerChange()">
              <el-button v-show="!disabled" class="is-enabled" type="primary">{{ $t('common.btn.confirm') }}</el-button>
              <el-button v-if="disabled" @click="showDialog=false">{{ $t('common.btn.close') }}</el-button>
            </label>
          </div>
        </span>
      </el-dialog>
    </el-form>
  </div>
</template>

<script>
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'

export default {
  name: 'SoNoInput',
  components: { },
	  props: {
	    value: { type: String, default: '' },
	    disabled: { type: Boolean, default: false },
	    title: { type: String, default: '' }
	  },
  data() {
    return {
      innerValue: '',
      firstLineVal: '', // 第一行的值
      showDialog: false,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        rowMultiSelectWithClick: true,
        suppressCellSelection: true,
        suppressRowSelection: false,
        suppressRowClickSelection: false,
        rowHeight: 32,
        frameworkComponents: { CargoAgGridCommonInputEditor },
        context: {
          componentParent: this
        },
        onRowDataChanged: event => {
          // 清除单选
          event.api.clearFocusedCell()
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        onRowClicked: p => {
          this.rowClicked(p)
        }
      },
      rowData: [],
      gridApi: null,
      selectedSoNo: null,
      tooltip: ''
    }
	  },
	  computed: {
	    resolvedTitle() {
	      return this.title ? this.title : this.$t('SeaExport.SoNo')
	    },
	    columnDefs() {
	      return [
	        {
	          headerName: this.resolvedTitle + this.$t('SeaExport.Select'),
	          field: 'text',
	          suppressMenu: true,
	          width: 400,
	          editable: !this.disabled,
          checkboxSelection: true,
          headerCheckboxSelection: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false,
            inputProps: {
              maxLength: 400
            }
          }
        }
      ]
    }
  },
  watch: {
    value(newVal) {
      this.innerValue = newVal
      this.toRowData()
      this.firstLineVal = this.rowData.length > 0 ? this.rowData[0].text : ''
      this.tooltip = newVal ? newVal.replace(/\n/g, '<br/>') : ''
    },
    firstLineVal(newVal) {
      if (this.rowData.length > 0) {
        this.rowData[0].text = newVal
      } else {
        if (newVal) {
          this.rowData.push({ text: newVal })
        }
      }
      this.save()
    },
    showDialog(newVal) {
      if (!newVal) {
        this.save()
        this.$emit('blur')
      }
    }
  },
  created() {
    if (this.value) {
      this.toRowData()
      this.tooltip = this.value.replace(/\n/g, '<br/>')
      this.firstLineVal = this.rowData.length > 0 ? this.rowData[0].text : ''
    }
  },
  methods: {
    toRowData() {
      const rowData = []
      if (this.value) {
        const values = this.value.split('\n')
        for (const text of values) {
          if (text.trim()) {
            rowData.push({ text })
          }
        }
      }
      this.rowData = rowData
    },
    rowClicked(event) {
      if (event) {
        this.selectedSoNo = event.data
      }
    },
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedSoNo = node.data
          }
        })
      }
    },
    add() {
      this.rowData.push({ text: '' })
      this.$nextTick(() => {
        this.gridApi.deselectAll()
        const nodes = this.gridApi.getRenderedNodes()
        const lastNode = nodes[nodes.length - 1]
        lastNode.setSelected(true)
        this.selectedSoNo = lastNode.data
      })
    },
    remove() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length) {
        this.rowData = this.rowData.filter(p => !rows.find(row => row === p))
      }
    },
    save() {
      if (this.disabled) {
        this.showDialog = false
        return
      }
      let text = ''

      this.rowData = this.rowData.filter(p => p.text.trim() !== '')

      for (const item of this.rowData) {
        // 过滤空字符串
        if (!item.text.trim()) {
          continue
        }
        if (text) {
          text += '\n'
        }
        text += item.text.trim()
      }

      this.tooltip = text.replace(/\n/g, '<br/>')
      this.firstLineVal = this.rowData.length > 0 ? this.rowData[0].text : ''
      this.innerValue = text
      this.$emit('input', text)
      this.showDialog = false
    },
    firstLineValBlur() { // 焦点离开，判断是否有值，有的话对数据做去两边空格处理
      if (this.firstLineVal) {
        this.firstLineVal = this.firstLineVal.trim()
      }
      this.$emit('blur')
    },
    triggerChange() {
      this.$nextTick(() => {
        this.$emit('change')
      })
    }
  }
}
</script>

<style lang="scss">
.so-no-input {
  display: flex;
  flex-direction: row;
  padding-right: 3px;
  .ag-header {
    display: none;
  }
  .is-enabled {
    color: #fff;
    background-color: #1890ff;
    border-color: #1890ff;
    cursor: pointer;
  }
}
</style>
